module.exports = __webpack_public_path__ + "img/logo_jyfw_516_210@2x.84c3db97.png";